<template>
  <div class="pay-pending">
    <img
      v-if="CheckCN()"
      :src="require('./imgs/cn@2x.png')"
      class="progress-img"
      alt=""
    />
    <img
      v-else
      :src="require('./imgs/en@2x.png')"
      class="progress-img"
      alt=""
    />
    <div>
      <img :src="require('./imgs/success@2x.png')" class="tips-img" alt="" />
    </div>
    <div class="order-status">
      {{ TLang("订单提交成功", "paypending") }}
    </div>
    <div class="progress-status">
      {{ TLang("审核中", "paypending") }}
    </div>
    <div class="progress-time">
      <span class="progress-label"
        >{{ TLang("审核剩余时间", "paypending") }}：</span
      >
      <span class="progress-time2">
        <span>{{ hh }}</span>
        :
        <span>{{ mm }}</span>
        :
        <span>{{ ss }}</span>
      </span>
    </div>
    <div class="order-tips">
      {{ TLang("审核通过后", "paypending") }}
    </div>
    <div class="buttons" @click="goDetail">
      {{ TLang("查看订单", "paypending") }}
    </div>
  </div>
</template>

<script>
import { getQueryString, countTime, getHourCountTime, unionFlag } from "@utils";
import { mapState, mapActions } from "vuex";
import Toast from "@components/simpleToast";
var clearInterval;
export default {
  name: "PayPending",
  components: {},
  data() {
    return { hh: "--", mm: "--", ss: "--" };
  },

  watch: {
    orderInfo: {
      handler(oldVal, newVal) {
        if (oldVal) {
          if (oldVal.auditStatus !== "audit") {
            Toast.info("订单已审核", 2, () => {
              this.goDetail();
            });
            return;
          }

          let dateStr = getQueryString("auditTimeoutAt");
          console.log('dateStr',dateStr);

          dateStr = oldVal.auditTimeoutAt;
          console.log('newdateStr',dateStr);
          if (clearInterval) {
            clearInterval(clearInterval);
          }
          if (dateStr) {
            // 分 && 秒
            clearInterval = window.setInterval(() => {
              const timeText = this.getTimeText(dateStr);
              console.log("timeText", timeText);
              this.hh = timeText.substr(0, 2);
              this.mm = timeText.substring(3, 5);
              this.ss = timeText.substring(6, 8);
            }, 998);
          }
        }
      },
      deep: true,
    },
  },

  created() {
    this.init();
  },
  computed: {
    ...mapState("orderDetail", ["orderInfo"]),
  },
  methods: {
    ...mapActions("orderDetail", ["getOrderDetailInfo"]),
    init() {
      const orderNo = getQueryString("orderNo");
      this.getOrderDetailInfo({ orderNo });
    },
    getTimeText(dateStr) {
      if (dateStr) {
        const nowTime = new Date();
        const closeTime = new Date(dateStr);
        if (closeTime > nowTime) {
          const lastTime = getHourCountTime(closeTime);
          return lastTime;
        }
      }
      return "";
    },
    goDetail() {
      let union = unionFlag() || sessionStorage.getItem('dffl_union');
      const orderNo = getQueryString("orderNo");
      let url = "/shop/order/detail/" + orderNo;
      if (union){
        url = url +'?union=' + union;
      }
      window.location.replace(url);
    },
  },
};
</script>

<style lang="less" scoped>
.pay-pending {
  margin-top: 50px;
  width: 1200px;
  height: 618px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(187, 187, 187, 0.25);
  border-radius: 2px;
  border: 1px solid #e5e5e5;
  text-align: center;
}
.progress-img {
  width: 690px;
  margin-top: 34px;
}
.tips-img {
  width: 260px;
  margin-top: 76px;
}
.order-status {
  height: 24px;
  font-size: 18px;
  font-weight: 500;
  color: #333333;
  line-height: 24px;
}

.progress-status {
  height: 42px;
  font-size: 30px;
  font-weight: 600;
  color: #ff6600;
  line-height: 42px;
  margin-top: 18px;
}

.progress-time {
  margin-top: 21px;
  text-align: center;
}
.progress-label {
  height: 16px;
  font-size: 14px;
  font-weight: 300;
  color: #666666;
  line-height: 16px;
}
.progress-time2 {
  height: 17px;
  font-size: 12px;
  font-weight: 600;
 
color: #FF6600;
  line-height: 17px;
   &>span{
        
        padding: 1px 2px;
        border-radius: 2px;
        border: 1px solid #E5E5E5;
      }
}
.order-tips {
  margin-top: 59px;
  text-align: center;
  font-size: 12px;
  font-weight: 300;
  color: #666666;
}
.buttons {
  margin-top: 12px;
  width: 112px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: linear-gradient(315deg, #5cb4ec 0%, #3d96e2 100%);
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
}
</style>
